import { useQuery } from "./useApi";
import { refereesService, type RefereesFilters } from "../api/referees.service";

export function useReferees(filters?: RefereesFilters) {
  return useQuery(
    () => refereesService.get(filters),
    [
      filters?.limit,
      filters?.offset,
      filters?.includeDeleted,
      filters?.publicationId,
      filters?.edition,
      filters?.regionId,
      filters?.editionId,
      filters?.rankingEntityId,
      filters?.bpaId,
      filters?.taxonomy,
      filters?.search,
      filters?.firmRef,
      filters?.surveyAnswered,
    ],
  );
}
